import React from 'react';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import Fastbooking from '../components/fastbooking';
import Middlesection from '../components/middleSection'
import Footer from '../components/footer'

import SectionContact from './sectionContact'

const pageContact = () =>{
  return (
    <div className='route-PageFaqs'>
      <FirstHeader />
      <Header isMenu={true} />

      <Fastbooking color='white'/>
      <Middlesection section='contact' />
      <SectionContact />

      <Footer />
    </div>
  )
}

export default pageContact;



// WEBPACK FOOTER //
// ./src/shared/routes/routeContact/index.js